// Intentionally empty.
//
// Replaces Next.js's built-in polyfill-module via Turbopack `resolveAlias`.
// Next ships polyfills for Array.prototype.at/.flat/.flatMap, Object.fromEntries,
// Object.hasOwn, URL.canParse, etc. into every page's runtime without feature
// detection, regardless of the project's browserslist. The polyfills total
// ~13 KiB and show up in Lighthouse's "Legacy JavaScript" insight on any
// modern-browser target.
//
// Our browserslist is pinned to Chrome 92+, Firefox 90+, Safari 15.4+, Edge 92+,
// all of which support the polyfilled APIs natively, so the polyfills are dead
// weight. Aliasing the polyfill module to this empty file drops them.
//
// Reference: https://github.com/vercel/next.js/discussions/64330
//
// If the browserslist is ever loosened to cover older browsers, this alias
// MUST be removed first or those browsers will hit ReferenceError on the
// missing methods.
